import { IPepDeclaration } from "api/compliance/types";
import { ListHeader } from "./types";

export function createListHeader(title: string, field: string, hiddenSort = false): ListHeader {
	return { title, field, hiddenSort };
}

export const listHeaderDeclaration: ListHeader[] = [
	createListHeader("Name", "name"),
	createListHeader("Position & Designation\n/Nature of Business", "type"),
	createListHeader("Country/Country of \nIncorporation", "shareholding"),
	createListHeader(
		"Relationship with PEP \n(only applicable to PEP's \nFamily Member or their \nClose Associates)",
		"registration",
	),
	createListHeader(
		"Whether PEC is still \nassociated to PEP, or\nPEP is still holding position?",
		"PEP",
	),
];

export const listHeaderDeclarationMobile = [
	"Name",
	"Position & Designation/Nature of Business",
	"Country/Country of Incorporation",
	"Relationship with PEP (only applicable to PEP's \nFamily Member or their Close Associates)",
	"Whether PEC is still associated to PEP, \norPEP is still holding position?)",
];
export const listHeaderDeclarationMobileEdit = [
	"Action",
	"Name",
	"Position & Designation/Nature of Business",
	"Country/Country of Incorporation",
	"Relationship with PEP (only applicable to PEP's \nFamily Member or their Close Associates)",
	"Whether PEC is still associated to PEP, \norPEP is still holding position?",
];
export const listHeaderShareholderRelationship: ListHeader[] = [
	createListHeader("Shareholder Name", "sName"),
	createListHeader("Shareholder Name (2)", "sName2"),
	createListHeader("Relationship", "relationship"),
	createListHeader("Shareholding (%) For Shareholder (2)", "shareHoldings"),
	createListHeader("NRIC/Passport No. For Shareholder (2)	", "nricPassport"),
];

export const listHeaderShareholderRelationshipMobile = [
	"Shareholder Name",
	"Shareholder Name (2)",
	"Relationship",
	"Shareholding (%) For Shareholder (2)",
	"NRIC/Passport No. For Shareholder (2)",
];
export const listHeaderShareholderRelationshipMobileEdit = [
	"Action",
	"Shareholder Name",
	"Shareholder Name (2)",
	"Relationship",
	"Shareholding (%) For Shareholder (2)",
	"NRIC/Passport No. For Shareholder (2)",
];
export const sortField: any = {
	transactionDate: "dateAnnounåcement",
	announcement: "announcement",
};

export const handleDataSelect = (listMetadata: { code: string; label: string }[] = []) => {
	const metaData: any = [];
	metaData.push({ value: "", label: "Please Select" });

	for (let i = 0; i < listMetadata.length; i++) {
		metaData.push({ value: listMetadata[i].code, label: listMetadata[i].label });
	}
	return metaData;
};

export const checkcontain = (arr: { value: any }[], value: any) => {
	for (let i = 0; i < arr.length; i += 1) {
		if (arr[i].value === value) {
			return true;
		}
	}
	return false;
};

export const checkIncludes = (dataAPI: [], dataDetail: IPepDeclaration) => {
	return dataAPI.find(
		(c: { value: string; label: string }) => c.value === dataDetail?.relationshipWithPep,
	);
};

export const handleDataSelectWithout = (listMetadata: { code: string; label: string }[] = []) => {
	const metaData: any = [];
	for (let i = 0; i < listMetadata.length; i++) {
		metaData.push({ value: listMetadata[i].code, label: listMetadata[i].label });
	}
	return metaData;
};
